import React from 'react';
import { withRouter } from 'react-router-dom';

import PropTypes from 'prop-types';

import './userAccountStatus.scss';

function UserAccountStatus(props) {
    const { setModalVisibility, setModalView, leadsQuota, totalLeadsQuota } =
        props;

    const calculateInvitesUsed = () => {
        return (leadsQuota / totalLeadsQuota) * 100;
    };

    return (
        <div className="user-account-status">
            <div className="row">
                <div className="user-account-status__bar">
                    <div
                        className="user-account-status__progress"
                        style={{ width: `${calculateInvitesUsed()}%` }}
                    />
                </div>
            </div>
            <p className="tw-text-blue-gray md:tw-text-black tw-text-xssm md:tw-text-sm tw-text-center md:tw-text-left">
                You are using{' '}
                <span className="tw-font-semibold tw-text-mobileTextBlack">
                    {leadsQuota} out of {totalLeadsQuota}
                </span>{' '}
                user accounts that you purchased.
            </p>
        </div>
    );
}

UserAccountStatus.propTypes = {
    setModalVisibility: PropTypes.func.isRequired,
    setModalView: PropTypes.func.isRequired,
    leadsQuota: PropTypes.number.isRequired,
    totalLeadsQuota: PropTypes.number.isRequired,
};

export default withRouter(UserAccountStatus);
